import Translate from 'i18n-react/dist/i18n-react';
import React from 'react';
import './_comment.scss';

import {THUMB_NAIL_SIZE} from '../../../constants/Design';
import {registeredUser} from '../../../constants/userTypes';
import {translate} from '../../../services';
import {UserType} from '../../../shapes/user';
import {isNotUndefined} from '../../../utils/validation';
import LazyImage from '../../Reusable/LazyImage/LazyImage';
import LinkWrapper from '../../Reusable/LinkWrapper/LinkWrapper';


export interface CommentProps {
  imageSource: string;
  userName: string;
  deletedComment: boolean;
  createdAt: Date;
  timeElapsedSinceCreation: string;
  userId?: number;
  userType?: UserType;
  parentId?: number;
  commentId: number;
  userOwnsComment: boolean;
  deleteComment: (commentId: number) => void;
  usersComment?: string;
  assignId?: (commentId: number) => void;
  replyIsClosed?: boolean;
}

const Comment = ({
  imageSource, userName, deletedComment, createdAt, timeElapsedSinceCreation, userId, userType, parentId, commentId,
  userOwnsComment, deleteComment, usersComment, assignId, replyIsClosed
}: CommentProps): JSX.Element => {
  const onClickAssignId = () => isNotUndefined(assignId) && assignId(commentId);
  const onClickDeleteComment = () => deleteComment(commentId);
  const isRegisteredUser = userType && registeredUser(userType);
  const userNameTranslation = Translate.translate('xurls.userProfile', {
    userName
  })?.toString() || ''; // TODO: SP-8362 Refactor or extend translate utility.
  const createdAtString = createdAt.toString() || '';

  return (
    <article className='b-comment'>
      <LazyImage
        className='user-image'
        src={imageSource}
        alt={userName}
        width={THUMB_NAIL_SIZE}
        height={THUMB_NAIL_SIZE}/>
      {!deletedComment && (
        <LinkWrapper
          className='user-name'
          hrefValue={userNameTranslation}
          contents={translate('designs.comments.commentAuthor', {
            user: userName
          })}
        />
      )}
      <time dateTime={createdAtString} className='time-elapsed' title={createdAtString}>{timeElapsedSinceCreation}</time>
      {(isNotUndefined(userId) && isRegisteredUser && !parentId) && usersComment &&
      <button
        type='button'
        className='reply-btn'
        onClick={onClickAssignId}
        aria-expanded={replyIsClosed}>
        {translate('designs.comments.reply')}
      </button>}
      {(isNotUndefined(userId) && (isNotUndefined(commentId)) && isRegisteredUser && userOwnsComment) &&
      <button className='delete-btn' onClick={onClickDeleteComment}>
        {translate('designs.comments.deleteComment')}
      </button>}
      {usersComment && <p className='user-comment'>{usersComment}</p>}
    </article>
  );
};

export default Comment;
